if (!customElements.get('royalty-order-bump')) {
  customElements.define('royalty-order-bump', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type=radio]')) return;
        this.querySelectorAll('.rob__item').forEach(item => {
          item.querySelector('.rob__variants').hidden = !item.querySelector('input').checked;
          item.querySelector('details').open = false;
        });
        this.querySelector('[data-action]').hidden = !this.querySelector('.rob__item input:checked');
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details');
        if (details) { details.open = false; details.querySelector('summary').focus(); }
      });
      this.addEventListener('click', event => {
        const variant = event.target.closest('button[data-variant]');
        if (variant && !variant.disabled) {
          const item = variant.closest('.rob__item');
          item.querySelectorAll('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
          item.querySelector('[data-variant-title]').textContent = variant.dataset.title;
          item.querySelector('strong[data-price]').textContent = variant.dataset.price;
          item.querySelector('s[data-old]').textContent = variant.dataset.old;
          item.querySelector('details').open = false;
          item.querySelector('summary').focus();
        }
        if (event.target.closest('.rob__add')) this.addPair();
      });
      this.querySelectorAll('.rob__item').forEach(item => {
        const selected = item.querySelector('[aria-pressed=true]');
        if (selected) item.querySelector('[data-variant-title]').textContent = selected.dataset.title;
      });
    }
    async addPair() {
      if (this.busy) return;
      const status = this.querySelector('.rob__status');
      const recovery = this.querySelector('.rob__recovery');
      const form = document.getElementById(this.dataset.formId);
      const selected = this.querySelector('.rob__item input:checked')?.closest('.rob__item').querySelector('[aria-pressed=true]');
      status.textContent = '';
      if (!selected || !form || form.tagName !== 'FORM') { status.textContent = this.dataset.formError; return; }
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const idControl = form.elements.namedItem('id');
      const id = data.get('id');
      const quantity = Number(data.get('quantity') || 1);
      const unsupported = [...data].some(([key,value]) => key.startsWith('items[') || (value instanceof File && value.size > 0));
      if (!/^\d+$/.test(String(id)) || idControl?.disabled || !Number.isInteger(quantity) || quantity < 1 || unsupported) {
        status.textContent = this.dataset.formError; return;
      }
      const main = {id: String(id), quantity, properties: {}};
      for (const [key,value] of data) {
        const property = key.match(/^properties\[(.+)\]$/);
        if (property && typeof value === 'string') main.properties[property[1]] = value;
      }
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      this.busy = true;
      this.setAttribute('aria-busy','true');
      const controls = [...this.querySelectorAll('button,input,summary')];
      const oldDisabled = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      status.textContent = this.dataset.loading;
      try {
        const response = await fetch(this.dataset.add, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[main,{id:selected.dataset.variant,quantity:1}]})
        });
        if (!response.ok) throw new Error('cart-add');
        window.location.assign(this.dataset.cart);
      } catch {
        status.textContent = this.dataset.error;
        recovery.hidden = false;
        this.querySelector('.rob__add').hidden = true;
      } finally {
        controls.forEach((control,index) => { control.disabled = oldDisabled[index]; });
        this.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
